module.exports = __webpack_public_path__ + "img/cut4img.bfc8ccbc.png";